import useSWRMutation from 'swr/mutation';

/**
 * リモートミューテーションを行う関数を返すhook。
 *
 * プロジェクト規約: mutation のエラーは `onSuccess` / `onError` でハンドリングする。
 * そのため `throwOnError: false` をデフォルトとし、Promise が reject されないようにしている。
 * 呼び出し側が明示的に `throwOnError: true` を渡した場合は従来動作（reject）になる。
 *
 * @param key {string} このリクエストのためのユニークなキー文字列
 * @param fetcher {(key: string, { arg }: { arg?: any }) => Promise<any>} データをフェッチするためのPromiseを返す関数
 * @param options {Object} オプション(https://swr.vercel.app/ja/docs/mutation#useswrmutation-parameters)
 * @returns {Object} { data, error, trigger, reset, isMutating }
 */
export const useMutation: typeof useSWRMutation = (key, fetcher, options) =>
  useSWRMutation(key, fetcher, {
    throwOnError: false,
    ...options,
  });
